// extracted by mini-css-extract-plugin
export default {"Select":"select_Select__W001P","errorInput":"select_errorInput__Hs3cn","fullWidth":"select_fullWidth__4yisX"};